import {
  Typography,
  Box,
  Grid,
  Divider,
  Button,
  AccordionSummary,
  Accordion,
  AccordionDetails,
  IconButton,
  useTheme,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  TableContainer,
  Paper,
  Tooltip,
} from "@mui/material";
import SecScoreAvg from "../../assets/baseVersion/SecScoreAvg.svg";
import SecScoreGood from "../../assets/baseVersion/SecScoreGood.svg";
import SecScoreLow from "../../assets/baseVersion/SecScoreLow.svg";
import React, { useEffect } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axiosInstance from "../../services/axiosInstance";
import CancelIcon from "@mui/icons-material/Cancel";
import InviteUpdateDrawer from "./InviteUpdateDrawer";
import { toast } from "react-toastify";
import {
  SA_ORG_PROFILE,
  SA_ORGANIZATIONS_LIST,
} from "../../shared/constants/apiEndpoints";
import { useAuth } from "../../services/auth/AuthContext";
import { frameworkLabels } from "../../shared/constants/frameworks";

// Helper to chunk fields into rows of 3
const chunk = (arr: any[], size: number) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size)
  );

interface InviteOrgTableDrawerProps {
  setIsTableRowClick: (value: boolean) => void;
  isSelectedRow?: any;
  onOrgUpdate?: () => void;
}

const InviteOrgTableDrawer: React.FC<InviteOrgTableDrawerProps> = ({
  setIsTableRowClick,
  isSelectedRow,
  onOrgUpdate,
}) => {
  const theme = useTheme();
  const { user } = useAuth();
  console.log(user, "userauth");
  const isDarkMode = theme.palette.mode === "dark";
  const [isPreview, setIsPreview] = React.useState<any>({});
  const [isUpdateButtonClicked, setIsUpdateButtonClicked] =
    React.useState(false);
  const [subscriptionStatus, setSubscriptionStatus] =
    React.useState<string>("");
  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axiosInstance.get(
          `/authentication/sa-organizations/${isSelectedRow}`
        );
      setSubscriptionStatus(response?.data?.data?.subscription_status || "");
        setIsPreview(response?.data?.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (isSelectedRow) {
      fetchData();
    } else {
      setIsLoading(false);
    }
  }, [isSelectedRow]);

  const fields = [
    {
      label: isPreview?.organization_name,
      value: isPreview?.organization_address || "—",
    },
    { label: "Admin Name", value: isPreview?.admin_full_name || "—" },
    {
      label: "Email",
      value: isPreview?.admin_email ? (
        <Tooltip
          title={isPreview.admin_email}
          arrow
          slotProps={{
            tooltip: {
              sx: {
                backgroundColor: "#fff",
                color: "#000",
                fontSize: "14px",
                boxShadow: 2,
              },
            },
            arrow: {
              sx: {
                color: "#fff",
              },
            },
          }}
        >
          <span style={{ cursor: "pointer" }}>
            {isPreview.admin_email.length > 15
              ? isPreview.admin_email.slice(0, 15) + "..."
              : isPreview.admin_email}
          </span>
        </Tooltip>
      ) : (
        "—"
      ),
    },
    { label: "Onboarding Date", value: isPreview?.onboarding_date || "—" },
    {
      label: "Subscription Type",
      value: isPreview?.subscription_details?.subscription_type || "—",
    },
    {
      label: "Deployment Type",
      value: isPreview?.subscription_details?.deployment_type || "—",
    },
    {
      label: "Inventory Type",
      value: isPreview?.subscription_details?.inventory_type || "—",
    },
    {
      label: "License Updated on",
      value: isPreview?.subscription_details?.license_updated_on || "—",
    },
    {
      label: "On-prem Assets",
      value: isPreview?.subscription_details?.on_prem_assets ?? "—",
    },
    {
      label: "Cloud Resources",
      value: isPreview?.subscription_details?.cloud_resources ?? "—",
    },
    {
      label: "Compliance Frameworks",
      value: Array.isArray(isPreview?.subscription_details?.frameworks)
        ? frameworkLabels(isPreview.subscription_details.frameworks) || "None"
        : "—",
    },
    {
      label: "On-prem Assets",
      value: isPreview?.scanned_assets ?? "—",
    },
    { label: "Cloud Resources", value: isPreview?.scanned_resources ?? "—" },
    { label: "Users", value: isPreview?.total_users ?? "—" },
  ];

  // const securityScoreField = {
  //   label: "Security Score",
  //   value: (
  //     <Box display="flex" alignItems="center" gap={1}>
  //       {typeof isPreview?.security_score === "number" ? (
  //         <>
  //           <img
  //             src={
  //               isPreview.security_score > 80
  //                 ? SecScoreGood
  //                 : isPreview.security_score > 40
  //                   ? SecScoreAvg
  //                   : SecScoreLow
  //             }
  //             alt="Security Score"
  //             style={{ width: 24, height: 24 }}
  //           />
  //           <span>{isPreview.security_score}</span>
  //         </>
  //       ) : (
  //         "—"
  //       )}
  //     </Box>
  //   ),
  // };

  const [firstField, ...restFields] = fields;
  const rows = chunk(restFields, 3);
  rows.forEach((row, idx) => {
    rows[idx] = row.filter((field) => field.label !== "Security Score");
  });
  // if (rows[2]) {
  //   rows[2].push(securityScoreField);
  // }

  const InviteTablerefetch = () => {
    axiosInstance.get(SA_ORGANIZATIONS_LIST).then((res) => {
      const organizationsData = res.data?.data || res.data;
      console.log("Refetched organizations:", organizationsData);
    });
  };
  const role = () => {
    console.log("role() function triggered"); // check if function runs
    axiosInstance
      .get(SA_ORG_PROFILE)
      .then((res) => {
        console.log("Raw response:", res); // log full response
        const profileData = res.data?.data || res.data;
        console.log("Refetched profile data:", profileData);
      })
      .catch((error) => {
        console.error("Error fetching SA_ORG_PROFILE:", error);
      });
  };

  return (
    <div>
      {isUpdateButtonClicked ? (
        <InviteUpdateDrawer
          isPreviewDetails={isPreview}
          isSelectedRow={isSelectedRow}
          setIsUpdateButtonClicked={setIsUpdateButtonClicked}
          setIsTableRowClick={setIsTableRowClick}
          onOrgUpdate={onOrgUpdate}
        />
      ) : (
        <Box sx={{ pl: 2, pr: 2, pb: 2 }}>
          {/* Header */}
          <Box>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
              mb={1}
            >
              <Typography
                variant="body2"
                sx={{ fontWeight: "bold", fontSize: "18px" }}
              >
                {firstField.label}
              </Typography>
              <IconButton
                sx={{ color: "#A6A5B6" }}
                onClick={() => setIsTableRowClick(false)}
                size="small"
              >
                <CancelIcon />
              </IconButton>
            </Box>

            <Typography
              variant="body2"
              fontWeight="bold"
              color="text.secondary"
            >
              {firstField.value}
            </Typography>
            <Divider sx={{ mt: 3, mb: 3 }} />
          </Box>

          {/* Fields Grid */}
          <Grid container spacing={2}>
            {rows.map((row, rowIdx) => (
              <React.Fragment key={rowIdx}>
                {rowIdx === 1 && (
                  <Grid item xs={12} mb={-1}>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: "bold", fontSize: "16px", mb: 1 }}
                    >
                      Subscription Details
                    </Typography>
                  </Grid>
                )}
                {rowIdx === 3 && (
                  <Grid item xs={12} mb={-1}>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: "bold", fontSize: "16px", mb: 1 }}
                    >
                      Activity Details
                    </Typography>
                  </Grid>
                )}
                <Grid container item spacing={2}>
                  {row.map((field: any, colIdx: number) => (
                    <Grid item xs={4} key={colIdx}>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontWeight: "bold", fontSize: "12px", mb: 1 }}
                      >
                        {field.label}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", fontSize: "14px" }}
                        color="text.secondary"
                      >
                        {field.value}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
              </React.Fragment>
            ))}
          </Grid>

          {/* History Accordion */}
          <div style={{ marginTop: 20 }}>
            <Accordion
              sx={{
                borderRadius: 2,
                bgcolor: isDarkMode ? "#181818" : "#F8F8FF",
                border: "1px solid #DBDBEF",
                boxShadow: "none",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={{
                  borderBottom: "1px solid #DBDBEF",
                  minHeight: "auto", // 👈 allow it to shrink
                  px: { xs: 1, sm: 2 }, // responsive padding
                  py: { xs: 1, sm: 1.5 },
                  "& .MuiAccordionSummary-content": {
                    margin: 0, // remove extra spacing
                  },
                }}
              >
                <Typography fontWeight={700} sx={{ xs: "14px", sm: "16px" }}>
                  History
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 0 }}>
                <TableContainer
                  className="scroll-x"
                  component={Paper}
                  sx={{
                    borderRadius: 2,
                    boxShadow: "none",
                    border: "none",
                    backgroundColor: isDarkMode ? "#181818" : "#F8F8FF",
                    overflowX: "auto",
                    overflowY: "hidden",
                    maxWidth: "100%",
                  }}
                >
                  <Table sx={{ minWidth: 650 }} size="small">
                    <TableHead>
                      <TableRow
                        sx={{
                          backgroundColor: isDarkMode ? "#202020" : "#F8F8FF",
                          borderBottom: "1px solid #DBDBEF",
                        }}
                      >
                        <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>
                          User Name
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Updates</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(isPreview?.history || []).map(
                        (item: any, index: number) => (
                          <TableRow
                            key={index}
                            sx={{
                              borderBottom: "1px solid #DBDBEF",
                              "&:last-child td": { borderBottom: "none" },
                            }}
                          >
                            <TableCell sx={{ fontSize: 14 }}>
                              {item.date || "—"}
                            </TableCell>
                            <TableCell sx={{ fontSize: 14 }}>
                              {item.user_name || "—"}
                            </TableCell>
                            <TableCell
                              sx={{
                                maxWidth: 400,
                                cursor: "pointer",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                fontSize: 14,
                              }}
                            >
                              <Tooltip
                                title={item.change_description || "—"}
                                arrow
                              >
                                <span>{item.change_description || "—"}</span>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>
          </div>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              gap: 2,
              mt: 6,
            }}
          >
            {user?.role !== "Super User Read Only" &&
              user?.role !== "Super User Invite Only" && (
                <>
                  {!isLoading && subscriptionStatus !== "Pending Activation" && (
                    <>
                      {subscriptionStatus === "Active" ? (
                         <Button
                          color="primary"
                          size="small"
                          sx={{
                            minWidth: 150,
                            minHeight: 35,
                            border: "1px solid #F53B3B",
                            color: "#F53B3B",
                            backgroundColor: "#fff",
                            "&:hover": {
                              backgroundColor: "#F53B3B",
                              color: "#fff",
                            },
                          }}
                          onClick={() => {
                            axiosInstance
                              .post(
                                `/authentication/sa-organizations/${isSelectedRow}/deactivate`
                              )
                              .then((response) => {
                                setIsTableRowClick(false);
                                toast.success(response?.data?.message);
                                onOrgUpdate?.();
                                InviteTablerefetch();
                              })
                              .catch((error: any) => {
                                console.error(
                                  "Error deactivating organization:",
                                  error
                                );
                                toast.error(error?.response?.data?.message);
                              });
                          }}
                        >
                          Deactivate License
                        </Button>
                      ) : (
                        <Button
                          color="primary"
                          size="small"
                          sx={{
                            minWidth: 150,
                            minHeight: 35,
                            border: "1px solid #3A2ADA",
                            color: "#3A2ADA",
                            backgroundColor: "#fff",
                            "&:hover": {
                              backgroundColor: "#3A2ADA",
                              color: "#fff",
                            },
                          }}
                          onClick={async () => {
                            try {
                              const response = await axiosInstance.post(
                                `/authentication/sa-organizations/${isSelectedRow}/activate`
                              );

                              // ✅ Success case
                              setIsTableRowClick(false);
                              toast.success(
                                response.data?.message ||
                                  "Organization activated successfully!"
                              );
                              onOrgUpdate?.();
                              InviteTablerefetch();
                              console.log("Activation successful:", response.data);
                            } catch (error: any) {
                              console.error("Activation failed:", error);

                              // ✅ Error handling
                              if (error.response) {
                                // Backend returned an error response
                                toast.error(
                                  error.response.data?.message ||
                                    "Failed to activate organization"
                                );
                              } else if (error.request) {
                                // Request made but no response
                                toast.error(
                                  "No response from server. Please try again later."
                                );
                              } else {
                                // Something else happened
                                toast.error("An unexpected error occurred.");
                              }
                            }
                          }}
                        >
                          Re-activate License
                        </Button>
                       
                      )}
                    </>
                  )}

                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    sx={{
                      minWidth: 150,
                      minHeight: 35,
                    }}
                    onClick={() => {
                      console.log(
                        "Update button clicked — calling SA_ORG_PROFILE API..."
                      );

                      role(); // 👈 trigger the API call
                      setIsUpdateButtonClicked(true);
                    }}
                  >
                    Update
                  </Button>
                </>
              )}
          </Box>
        </Box>
      )}
    </div>
  );
};

export default InviteOrgTableDrawer;
